import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import Alert from '@mui/material/Alert'
import Box from '@mui/material/Box'
import {
  readWebSurveyPhoneVerified,
  webSurveyMobileOnboardingPath,
} from '@/features/auth/lib/constants'
import { webSurveyAccountPageSx } from '../styles/webSurveyAccountStyles'

interface WebSurveyAccountSessionGateProps {
  readonly sessionId: string | null
  readonly children: ReactNode
}

/** Session / phone-verification guards for WebSurveyAccountPage (S3776). */
export function WebSurveyAccountSessionGate({
  sessionId,
  children,
}: WebSurveyAccountSessionGateProps) {
  if (!sessionId) {
    return (
      <Box sx={webSurveyAccountPageSx}>
        <Alert severity="error" role="alert">
          Your survey session expired. Please use the link from your SMS to continue.
        </Alert>
      </Box>
    )
  }

  if (!readWebSurveyPhoneVerified()) {
    return <Navigate to={webSurveyMobileOnboardingPath()} replace />
  }

  return children
}
